export default __webpack_public_path__ + "static/media/fMaltoBuza11.6bd6fd72.png";